import React from 'react';
import TypeRegroupement from '../../constants/feuilleSaisie/typeRegroupement';
import TypePeriode from '../../constants/simulation/typePeriode';
import type TreeRow from '../../interfaces/feuilleSaisie/treeRow';
import { getMontantImputation } from '../../utils/feuilleSaisie/imputation';
import type BaseFeuilleSaisie from '../feuilleSaisies/BaseFeuilleSaisie';
import BaseTypeRegroupement from './BaseTypeRegroupement';

class SensTypeRegroupement extends BaseTypeRegroupement {
	constructor() {
		super();
		this.code = TypeRegroupement.SENS;
		this.codeColumnName = 'imp_sens';
		this.icon = {
			iconSet: 'Lucide',
			name: 'Book',
		};
		this.libelle = 'Sens';
	}

	getLibelle(data: TreeRow, _feuille: BaseFeuilleSaisie): string {
		if (data[this.codeColumnName] === 'R') {
			return 'Recette';
		}

		if (data[this.codeColumnName] === 'D') {
			return 'Dépense';
		}

		return '';
	}

	getTabLibelle(data: TreeRow): React.JSX.Element {
		return <>{this.getLibelle(data, null)}</>;
	}

	getSolde(data: TreeRow) {
		const depenseRow = data?.children?.find((row) => row.imp_sens === 'D');
		const recetteRow = data?.children?.find((row) => row.imp_sens === 'R');

		return {
			libelle: 'SOLDE',
			report: (recetteRow?.report ?? 0) - (depenseRow?.report ?? 0),
			budget: (recetteRow?.budget ?? 0) - (depenseRow?.budget ?? 0),
			budget_n1: (recetteRow?.budget_n1 ?? 0) - (depenseRow?.budget_n1 ?? 0),
			budget_n2: (recetteRow?.budget_n2 ?? 0) - (depenseRow?.budget_n2 ?? 0),
			realise: (recetteRow?.realise ?? 0) - (depenseRow?.realise ?? 0),
			realise_n1: (recetteRow?.realise_n1 ?? 0) - (depenseRow?.realise_n1 ?? 0),
			realise_n2: (recetteRow?.realise_n2 ?? 0) - (depenseRow?.realise_n2 ?? 0),
			bp_n1: (recetteRow?.bp_n1 ?? 0) - (depenseRow?.bp_n1 ?? 0),
			bp_n2: (recetteRow?.bp_n2 ?? 0) - (depenseRow?.bp_n2 ?? 0),
			liquide_n: (recetteRow?.liquide_n ?? 0) - (depenseRow?.liquide_n ?? 0),
			engage_n: (recetteRow?.engage_n ?? 0) - (depenseRow?.engage_n ?? 0),
			solde: (recetteRow?.solde ?? 0) - (depenseRow?.solde ?? 0),
			montant_demande:
				(getMontantImputation(recetteRow, TypePeriode.DEMANDE) ?? 0) -
				(getMontantImputation(depenseRow, TypePeriode.DEMANDE) ?? 0),
			montant_propose:
				(getMontantImputation(recetteRow, TypePeriode.PROPOSE) ?? 0) -
				(getMontantImputation(depenseRow, TypePeriode.PROPOSE) ?? 0),
			montant_vote:
				(getMontantImputation(recetteRow, TypePeriode.VOTE) ?? 0) -
				(getMontantImputation(depenseRow, TypePeriode.VOTE) ?? 0),
			rar: (recetteRow?.rar ?? 0) - (depenseRow?.rar ?? 0),
		};
	}
}

export default SensTypeRegroupement;
